import { render, staticRenderFns } from "./ContactV2.vue?vue&type=template&id=1606efa0&scoped=true&"
import script from "./ContactV2.vue?vue&type=script&lang=js&"
export * from "./ContactV2.vue?vue&type=script&lang=js&"
import style0 from "./ContactV2.vue?vue&type=style&index=0&id=1606efa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1606efa0",
  null
  
)

export default component.exports